import React from "react";
import { Box, Paper, Typography, Grid, Divider } from "@mui/material";

/**
 * Reusable job Card Component
 * --------------------------------
 * @param {Object} props
 * @param {Object} props.job - job data
 * @param {boolean} props.loading - Optional: show skeleton or dim state
 */
const JobCard = ({ job, loading = false, onClick }) => {
    if (!job) return null;

    return (
        <Paper
            elevation={0}
            onClick={!loading ? onClick : undefined}
            sx={{
                backgroundColor: "white !important",
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                borderRadius: "16px",
                overflow: "hidden",
                opacity: loading ? 0.5 : 1,
                cursor: loading ? "default" : "pointer",
                p: { xs: 2, sm: 3 },
                minHeight: {
                    xs: 120,   // mobile
                    sm: 120,   // tablet
                    md: 150,   // desktop
                },
                display: "flex",
                color: '#002045',
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "all 0.3s ease",
                "&:hover": {
                    boxShadow: loading ? "none" : "0 8px 24px rgba(0,0,0,0.12)",
                },
            }}
        >
            <Box sx={{ p: 1 }}>
                {/* ---------- Course Title ---------- */}
                <Typography
                    sx={{
                        fontSize: { xs: "16px", sm: "18px" },
                        fontWeight: 600,
                        color: "#002045",
                        mb: 1.5,
                        textTransform:'capitalize'
                    }}
                >
                    {job.job_title}
                </Typography>

                <Divider
                    sx={{
                        height: "0.5px",
                        backgroundColor: "#e0e0e0",
                        mb: 1.5,
                    }}
                />

                {/* ---------- Details Layout ---------- */}
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Box>
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",           // ✅ mobile = single column
                                        sm: "1fr 1fr",       // ✅ tablet = 2 columns
                                        md: "repeat(4, 1fr)" // ✅ desktop = 4 columns
                                    },
                                    gap: { xs: 2, md: 3 },
                                }}
                            >
                                {/* Description */}
                                <Box>
                                    <Typography fontWeight={600} color="#002045" fontSize={14}>
                                        Description
                                    </Typography>
                                    <Typography color="#002045" fontSize={14}>
                                        {job.job_desc || "--"}
                                    </Typography>
                                </Box>

                                {/* Email */}
                                <Box>
                                    <Typography fontWeight={600} color="#002045" fontSize={14}>
                                        Company Email
                                    </Typography>
                                    <Typography
                                        color="#002045"
                                        fontSize={14}
                                        sx={{ wordBreak: "break-all" }} // ✅ FIX long email
                                    >
                                        {job.company_email || "--"}
                                    </Typography>
                                </Box>

                                {/* Contact */}
                                <Box>
                                    <Typography fontWeight={600} color="#002045" fontSize={14}>
                                        Company Contact
                                    </Typography>
                                    <Typography color="#002045" fontSize={14}>
                                        {job.company_mobile || "--"}
                                    </Typography>
                                </Box>

                                {/* Location */}
                                <Box>
                                    <Typography fontWeight={600} color="#002045" fontSize={14}>
                                        Job Location
                                    </Typography>
                                    <Typography
                                        color="#002045"
                                        fontSize={14}
                                        sx={{ wordBreak: "break-word" }} // ✅ FIX long text
                                    >
                                        {job.job_location || "--"}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Website (Full Width) */}
                            <Box mt={3}>
                                <Typography fontWeight={600} color="#002045" fontSize={14}>
                                    Job Website
                                </Typography>
                                <Typography
                                    color="#002045"
                                    fontSize={14}
                                    sx={{ wordBreak: "break-all" }}
                                >
                                    {job.job_website || "--"}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default JobCard;
